import React from "react";
import styled from "styled-components";
import { FiMusic, FiMapPin, FiActivity, FiBookOpen, FiSmile, FiLock, FiStar, FiPlayCircle } from "react-icons/fi";
import { Colors } from "../utils/colors";
import { Sizes } from "../utils/sizes";

const Wrap = styled.section`
  width: 100%;
  background: #0a0a0a;
  padding: 80px 24px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255,215,0,0.2), transparent);
  }
`;

const Inner = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 52px;
`;

const Label = styled.p`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: ${Colors.yellow};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 0 0 10px;
`;

const Title = styled.h2`
  color: #fff;
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 800;
  margin: 0;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  @media (max-width: ${Sizes.mediaQueryBreak2}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${Sizes.mediaQueryBreak3}) {
    grid-template-columns: 1fr;
    max-width: 400px;
    margin: 0 auto;
  }
`;

const Card = styled.div`
  background: #161616;
  border: 1px solid rgba(255,215,0,0.08);
  border-radius: 12px;
  padding: 28px 24px;
  display: flex;
  gap: 18px;
  align-items: flex-start;
  transition: border-color 0.2s, background 0.2s;

  &:hover {
    border-color: rgba(255,215,0,0.25);
    background: #1c1c1c;
  }
`;

const Icon = styled.div`
  width: 44px;
  height: 44px;
  background: rgba(255,215,0,0.08);
  border: 1px solid rgba(255,215,0,0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.yellow};
  font-size: 20px;
  flex-shrink: 0;
`;

const CardText = styled.div`
  h4 {
    color: #fff;
    font-size: 0.95rem;
    font-weight: 700;
    margin: 0 0 6px;
  }
  p {
    color: rgba(255,255,255,0.5);
    font-size: 0.83rem;
    line-height: 1.5;
    margin: 0;
  }
`;

const YoutubeLink = styled.a`
  display: flex;
  align-items: center;
  gap: 14px;
  background: #1a1a1a;
  border: 1px solid rgba(255,215,0,0.12);
  border-radius: 12px;
  padding: 20px 24px;
  margin-top: 20px;
  text-decoration: none;
  transition: border-color 0.2s, background 0.2s;
  grid-column: 1 / -1;

  &:hover {
    border-color: rgba(255,215,0,0.3);
    background: #222;
  }

  .yt-icon {
    font-size: 28px;
    flex-shrink: 0;
  }

  .yt-text {
    h4 { color: ${Colors.yellow}; font-size: 0.95rem; font-weight: 700; margin: 0 0 4px; }
    p { color: rgba(255,255,255,0.5); font-size: 0.83rem; margin: 0; }
  }

  .yt-arrow {
    margin-left: auto;
    color: rgba(255,255,255,0.3);
    font-size: 1.2rem;
  }
`;

const benefits = [
  { icon: FiMusic, title: 'Cifras simplificadas', desc: 'Fácil de ler e aplicar direto na prática.' },
  { icon: FiMapPin, title: 'Cifras sobre a letra', desc: 'Acorde exatamente na sílaba certa.' },
  { icon: FiActivity, title: 'Indicação rítmica', desc: 'Saiba qual ritmo usar em cada música.' },
  { icon: FiBookOpen, title: 'Dicionário de acordes', desc: 'Aprenda qualquer acorde com facilidade.' },
  { icon: FiSmile, title: 'Músicas sem pestana', desc: 'Ideal para iniciantes e intermediários.' },
  { icon: FiLock, title: 'Acesso vitalício', desc: 'Pague uma vez e use para sempre.' },
];

const Section = () => {
  return (
    <Wrap>
      <Inner>
        <Header>
          <Label><FiStar size={13} /> Benefícios</Label>
          <Title>O que está incluso em cada e-book</Title>
        </Header>
        <Grid>
          {benefits.map((b) => (
            <Card key={b.title}>
              <Icon><b.icon /></Icon>
              <CardText>
                <h4>{b.title}</h4>
                <p>{b.desc}</p>
              </CardText>
            </Card>
          ))}
          <YoutubeLink
            href="https://www.youtube.com/violaocatolico"
            target="_blank"
            rel="noreferrer"
          >
            <span className="yt-icon"><FiPlayCircle size={22} /></span>
            <div className="yt-text">
              <h4>Videoaula para todas as músicas</h4>
              <p>Assista gratuitamente no canal do YouTube — Viola Católico</p>
            </div>
            <span className="yt-arrow">›</span>
          </YoutubeLink>
        </Grid>
      </Inner>

    </Wrap>
  );
};

export default Section;
